export enum UnitOfMeasureType {
  Kg,
  M,
  Unit,
  Lb,
  L,
  Yd,
  G,
  Gal,
  Box,
  Pack,
  Bkt,
  Rl,
  Pc,
  Thr,
  Ft,
  Set,
  Kit,
  Pair,
  Btl,
  Qt,
  Sck,
  Bag,
  Tub,
  Oz,
  Drm,
  Mm,
  M3,
}

export const UNIT_OF_MEASURE_LABELS: Record<UnitOfMeasureType, string> = {
  [UnitOfMeasureType.Kg]: 'kg',
  [UnitOfMeasureType.M]: 'm',
  [UnitOfMeasureType.Unit]: 'unit',
  [UnitOfMeasureType.Lb]: 'lb',
  [UnitOfMeasureType.L]: 'L',
  [UnitOfMeasureType.Yd]: 'yd',
  [UnitOfMeasureType.G]: 'g',
  [UnitOfMeasureType.Gal]: 'gal',
  [UnitOfMeasureType.Box]: 'box',
  [UnitOfMeasureType.Pack]: 'pack',
  [UnitOfMeasureType.Bkt]: 'bkt',
  [UnitOfMeasureType.Rl]: 'rl',
  [UnitOfMeasureType.Pc]: 'pc',
  [UnitOfMeasureType.Thr]: 'thr',
  [UnitOfMeasureType.Ft]: 'ft',
  [UnitOfMeasureType.Set]: 'set',
  [UnitOfMeasureType.Kit]: 'kit',
  [UnitOfMeasureType.Pair]: 'pair',
  [UnitOfMeasureType.Btl]: 'btl',
  [UnitOfMeasureType.Qt]: 'qt',
  [UnitOfMeasureType.Sck]: 'sck',
  [UnitOfMeasureType.Bag]: 'bag',
  [UnitOfMeasureType.Tub]: 'tub',
  [UnitOfMeasureType.Oz]: 'oz',
  [UnitOfMeasureType.Drm]: 'drm',
  [UnitOfMeasureType.Mm]: 'mm',
  [UnitOfMeasureType.M3]: 'm³',
};
